export const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1024 },
      items: 5,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1024, min: 800 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 800, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


 export const productData = [
    {
        id: 1,
        imageurl: "/images/27.jpg",
        name: "name",
        price: "$24.99",
        description: "Some description about products..."
    },

    {
        id: 2,
        imageurl: "/images/41.jpg",
        name: "name",
        price: "$23.99",
        description: "Some description about products..."
    },

    {
        id: 3,
        imageurl: "/images/29.jpg",
        name: "name",
        price: "$21.99",
        description: "Some description about products..."
    },
    {
        id: 4,
        imageurl: "/images/40.jpg",
        name: "name",
        price: "$22.99",
        description: "Some description about products..."
    },
    {
        id: 5,
        imageurl: "/images/31.jpg",
        name: "name",
        price: "$25.99",
        description: "Some description about products..."
    },
    {
        id: 6,
        imageurl: "/images/42.jpg",
        name: "name",
        price: "$26.99",
        description: "Some description about products..."
    },
    {
        id: 7,
        imageurl: "/images/32.jpg",
        name: "name",
        price: "$27.99",
        description: "Some description about products..."
    },
    {
        id: 8,
        imageurl: "/images/34.jpg",
        name: "name",
        price: "$28.99",
        description: "Some description about products..."
    },
    {
        id: 9,
        imageurl: "/images/44.jpg",
        name: "name",
        price: "$29.99",
        description: "Some description about products..."
    },
  
    
  ];
